import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { phoneNormalize } from 'shared/modules';
import cx from 'classnames';
import s from './ContactButton.css';

const isMobile = __APP__ === 'mobile';

const ShowedContacts = ({ phones }) =>
  <div className={isMobile ? null : s.showedContainerDesktop}>
    {phones.length
      ? phones.map(phone => {
          const nPhone = phoneNormalize(phone);
          return (
            <a href={`tel:${nPhone}`} className={isMobile ? s.showedPhoneMobile : null} key={phone}>
              {nPhone}
            </a>
          );
        })
      : <FormattedMessage id="Нет телефонов" />}
  </div>;

const HidedContacts = ({ clickHandler }) =>
  <button className={cx(s.hided, { [s.hidedMobile]: isMobile })} onClick={clickHandler}>
    <span className={s.hidedContent}>
      <FormattedMessage id="Показать телефон" />
      <span className={s.hiddenPhone}>
        <span className={s.Plus}>+</span>
        <span className={s.Dots}>••• •• ••• •• ••</span>
      </span>
    </span>
  </button>;

class ContactButton extends React.Component {
  static propTypes = {
    clickHandler: PropTypes.func,
    loadPhones: PropTypes.func,
    phones: PropTypes.arrayOf(PropTypes.shape()),
  };

  static defaultProps = {
    phones: [],
    clickHandler: () => {},
    loadPhones: cb => cb([]),
  };

  state = {
    isShowed: false,
    phones: [],
  };

  onClick(e) {
    this.props.loadPhones(phones => {
      this.setState({ isShowed: true, phones });
    });
    this.props.clickHandler(e);
  }

  render() {
    const phonesState = this.props.phones.length ? this.props.phones : this.state.phones;
    const phones = phonesState.map(phone => (phone.number ? phone.number : phone));
    return (
      <React.Fragment>
        {this.state.isShowed
          ? <ShowedContacts phones={phones} />
          : <HidedContacts clickHandler={e => this.onClick(e)} />}
      </React.Fragment>
    );
  }
}

ShowedContacts.propTypes = {
  phones: PropTypes.arrayOf(PropTypes.string),
};

ShowedContacts.defaultProps = {
  phones: [],
};

HidedContacts.propTypes = {
  clickHandler: PropTypes.func,
};

HidedContacts.defaultProps = {
  clickHandler: () => {},
};

export default withStyles(s)(ContactButton);



// WEBPACK FOOTER //
// ./src/shared/components/UI/ContactButton/ContactButton.js